import { AfterViewInit, ChangeDetectionStrategy, Component, Input, model, OnChanges, signal, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseListCombinedService } from '../../../../@core/services/base-list-combined.service';
import { Address, AddressContactLink, DeletionResult, Operator, SearchInput } from '../../../../generated/generated-types';
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from '../../../../shared/components/new-base-list-component/new-base-list-component';
import { AddressContactLinkService } from '../../services/address-contact-link.service';
import { AddressContactLinkEditWidgetComponent } from '../address-contact-link-edit-widget/address-contact-link-edit-widget.component';

@Component({
  selector: 'widget-address-contact-link-list',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  providers: [AddressContactLinkService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent
  ]
})
export class WidgetAddressContactLinkListComponent extends NewBaseListComponent<AddressContactLink> implements OnChanges, AfterViewInit {

  addressModelSig = model<Address>();

  // This addressId might needs to be deprecated and replaced by addressModelSig, since it sensitive data, making possible to detect address changes, avoiding unnecessary refreshes or requests.
  @Input()
  addressId: string;

  // Set inactiveItems to true to show inactive Switcher
  override hasInactiveProperty = signal(true);

  constructor(
    protected addressContactLinkService: AddressContactLinkService,
    private baseListServices: BaseListCombinedService
  ) {

    super("AddressContactLink", addressContactLinkService);

  }

  async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.addressContactLinkService.subscribe(x => {
      if (x)
        this.cdRef.detectChanges();
    });
  }

  async ngOnChanges(c: SimpleChanges) {
    if (c.addressId.currentValue) {
      // this.buildFilter();
      if (this.initialFetchExecuted)
        this.refresh();
    }

  }

  override getSearchInputForQuery(): SearchInput {
    let si = super.getSearchInputForQuery();

    this.addressContactLinkService.applySearchRule(si, {
      field: "addressId",
      operator: Operator.equal,
      value: this.addressId
    });

    return si;
  }

  override addNewItem(index?: number, item?: AddressContactLink): void {
    item = {} as AddressContactLink;
    item.addressId = this.addressId;
    super.addNewItem(index, item);
  }

  onRowEditSave(rowData: AddressContactLink) {
    if (this.addressId)
      rowData.addressId = this.addressId;
    else {
      this.baseListServices.notificationService.error(this.baseListServices.i18nService.translate(_("crm.need-address-id-to-save-contact-link")));
      return;
    }
    return super.onRowEditSave(rowData);
  }

  showEditDialog(rowData?: AddressContactLink) {
    let detailModel = rowData;
    let me = this;

    detailModel.address = this.addressModelSig();

    let modal$ = this.baseListServices.modalService.fromComponent(AddressContactLinkEditWidgetComponent, {
      size: 'md',
      verticalAlign: 'top',
      closable: true,
      title: this.baseListServices.i18nService.translate(_("crm.address-contact-link-edit")),
      locals: {
        detailModel: detailModel,
        addressId: this.addressId ?? detailModel?.addressId ?? detailModel?.address?.id,
        insideEditEnabled: false
      }
    });
    let sub = modal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: async (res: { result: AddressContactLink, isDirty: boolean, firstTimeSaveDone: boolean }) => {
        //TODO handle more performant / fine tune in v2
        if (!res.isDirty && res.firstTimeSaveDone) {
          // Because of automatic save on AddressContactLinkEditWidgetComponent line 119, we need to delete back the item from the list.
          if (res?.result?.id) {
            const deletedResult = await this.addressContactLinkService.deleteItem(res.result.id);
            if (deletedResult.result == DeletionResult.DELETED) {
            } else {
              this.baseListServices.notificationService.error(deletedResult.message);
            }
          }
        }

        let existing = me.itemsSig().find(x => x?.id == res.result?.id);
        if (!existing)
          me.setItems([...me.itemsSig(), res.result]);
        else {
          let i = me.itemsSig().indexOf(existing);
          me.itemsSig()[i] = res.result;
        }
        me.cdRef.detectChanges();
        this.refresh();
        return;
      },
      error: (err) => {
        console.error("Error in modal subscription:", err);
      },
      complete: () => {
        sub.unsubscribe();
      }
    });
  }
}
